import React from 'react';

import R2Image from '@/components/ui/R2Image';
import RichText from '@/components/ui/RichText/RichText';

import type { CardLabels } from '@/types/packageCard';
import { ChevronIcon } from './icons';

interface IncludedTestsHeaderProps {
  open: boolean;
  showToggle: boolean;
  onToggle: () => void;
  labels: CardLabels;
}

export default function IncludedTestsHeader({
  open,
  showToggle,
  onToggle,
  labels,
}: IncludedTestsHeaderProps): React.ReactElement {
  const expandLabel = labels.expandLabel?.content ?? 'View All';
  const collapseLabel = labels.collapseLabel?.content ?? 'View Less';
  const toggleLabel = open ? collapseLabel : expandLabel;

  return (
    <div
      className={`flex items-center justify-between ${open ? 'pt-4' : 'mt-4'}`}
    >
      <div className="flex items-center">
        <R2Image
          path="/images/healthpackages/file-text-icon.svg"
          alt="Included"
          width={20}
          height={20}
          className="shrink-0 object-contain"
        />
        <div className="ml-2">
          <RichText styles={labels.includedTestsLabel?.styles}>
            {labels.includedTestsLabel?.content ?? 'Included Tests'}
          </RichText>
        </div>
      </div>

      {showToggle && (
        <button
          type="button"
          onClick={onToggle}
          aria-expanded={open}
          aria-label={toggleLabel}
          className="flex cursor-pointer items-center justify-center gap-2 p-0"
        >
          <span className="font-regular text-theme-brand-blue text-base">
            {toggleLabel}
          </span>
          <ChevronIcon open={open} />
        </button>
      )}
    </div>
  );
}
